import clsx from 'clsx';
import React from 'react';

import type { CurrencyCode } from '@fragment/types/currencyCodes';

import { type TextSizeType, sizeToTextClassName } from '../utils';

const formatCurrency = (
  amount: number,
  currencyPrecision: number,
  currencyCode: CurrencyCode
) =>
  `${(amount / 10 ** currencyPrecision).toFixed(
    currencyPrecision
  )} ${currencyCode}`;

export const CurrencyField = ({
  amount,
  currencyPrecision,
  currencyCode,
  textSize,
  align,
  paid,
  'data-testid': dataTestId,
}: {
  amount: number;
  currencyPrecision: number;
  currencyCode: CurrencyCode;
  textSize: TextSizeType;
  align: 'left' | 'right' | 'center';
  paid?: boolean;
  'data-testid'?: string;
}) => (
  <span
    className={clsx(
      'flex flex-row w-full h-fit text-main font-FragmentMono gap-x-[1ch]',
      sizeToTextClassName[textSize],
      align === 'left' && 'justify-start',
      align === 'center' && 'justify-center text-center',
      align === 'right' && 'justify-end text-right',
      paid && 'line-through text-main-500'
    )}
    data-testid={dataTestId ?? 'currency-text-field'}
  >
    {formatCurrency(amount, currencyPrecision, currencyCode)}
  </span>
);
